module.exports = __webpack_public_path__ + "static/media/original-charts-2-mobile.dbdc8da9.jpg";